export default "__VITE_ASSET__D8Maa8IC__"